import React, { useEffect, useState } from "react";
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  fetchReservationsDetailReport,
  initializeReservationsDetailReportScreen,
  setDeleteConfirmationPopupVisibility,
  exportReservationsDetailReport,
  setDetailReportFilters,
  clearDetailReportFilters,
  setDetailReportTableColumnFilters,
  clearDetailReportTableColumnFilters,
  saveDetailReportTableState,
} from "../../../redux/actions/Reservations/ReservationsDetailReport";
import { fetchLocationDD } from "../../../redux/actions/location";
import { fetchRateAdminNetworkDD } from "../../../redux/actions/RateAdmin/rateadminRates";
import ReservationsDetailReport from "../../../component/Reservations/ReservationsDetailReport";
import { generatePath } from "react-router-dom";
import { loadingShow } from "../../../services/PostAPI";
import { APP_URLS } from "../../../utils/constant";
import { ProgressBar } from "primereact/progressbar";
import { setIsSearch } from "../../../redux/actions/common/search";
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
import { useRef } from "react";
function ReservationsDetailReportScreen(props) {
  const {
    fetchReservationsDetailReport,
    initReservationsDetailReportScreen,
    showPageLevelLoader,
    ReservationsDetailReportListview,
    paginationInfo,
    screenPermissions,
    exportReservationsDetailReport,
    isReservationsDetailReportExportError,
    isReservationsDetailReportExportSuccess,
    isLoading,
    fetchLocationDD,
    fetchRateAdminNetworkDD,
    RateNetworkDD,
    locationDD,
    isSearch,
    setIsSearch,
    detailReportFilters,
    setDetailReportFilters,
    clearDetailReportFilters,
    tableColumnFilters,
    setDetailReportTableColumnFilters,
    clearDetailReportTableColumnFilters,
    savedTableState,
    saveDetailReportTableState,
  } = props;
  const navigate = useNavigate();
  const location = useLocation();

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined,
      userId: localStorage.getItem("userId"),
      additinalFilter: detailReportFilters,
    };
  };

  const callAPIasync = async () => {
    await fetchRateAdminNetworkDD();
    await fetchLocationDD();
  };

  useEffect(() => {
    callAPIasync();
    
    // Check if coming from detail page (back button) BEFORE calling init
    const isFromDetail = location.state?.fromDetail;
    
    if (isFromDetail) {
      // Coming back from detail page - DO NOT call init, preserve filters
      // Fetch with saved table state params if available, otherwise use defaults
      const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
      
      if (savedParams) {
        fetchReservationsDetailReport(savedParams);
      } else {
        // Build column filters array from tableColumnFilters for API call
        const columnFilters = Object.entries(tableColumnFilters || {}).map(([key, value]) => ({
          filterField: key,
          matchStrategy: 'CONTAINS',
          query: value
        })).filter(f => f.query);
        
        // Use saved pagination from initialSavedState if available
        const savedState = initialSavedState.current;
        
        // Fetch with preserved filters and pagination
        fetchReservationsDetailReport({
          pageNumber: savedState?.page || 0,
          pageSize: savedState?.rows || 10,
          sortField: savedState?.sortField || "id",
          sortOrder: savedState?.sortOrder,
          userId: localStorage.getItem("userId"),
          additinalFilter: detailReportFilters,
          filters: columnFilters,
        });
      }
      // Clear the navigation state
      navigate(location.pathname, { replace: true, state: {} });
    } else {
      // Coming from any other menu - call init and clear all filters
      initReservationsDetailReportScreen();
      clearDetailReportFilters();
      clearDetailReportTableColumnFilters();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    let newProps = {
      ...props,
      userId: localStorage.getItem("userId"),
      additinalFilter: props.additinalFilter ?? detailReportFilters,
    };
    fetchReservationsDetailReport(newProps);
  };
  const handleCreateReservationsDetailReport = () => {
    navigate(APP_URLS.RESERVATIONS_DETAILREPORT.CREATE);
  };
  const editReservationsDetailReportRoute = (id) => {
    const path = generatePath(APP_URLS.RESERVATIONS_DETAILREPORT.EDIT, {
      id,
    });
    navigate(path);
  };
  const viewReservationRoute = (id) => {
    navigate(`/view-reservations/${id}/view`, { state: { fromDetailReport: true } });
  };

  const handleTableStateChange = (tableState) => {
    saveDetailReportTableState(tableState);
  };

  const ReservationsDetailReportProps = {
    handleCreateReservationsDetailReport,
    exportReservationsDetailReport,
    isReservationsDetailReportExportError,
    isReservationsDetailReportExportSuccess,
    editReservationsDetailReportRoute,
    viewReservationRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    fetchReservationsDetailReports: loadLazyData,
    tableData: {
      columns: ReservationsDetailReportListview?.columns,
      rows: ReservationsDetailReportListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    RateNetworkDD,
    locationDD,
    setIsSearch,
    detailReportFilters,
    setDetailReportFilters,
    clearDetailReportFilters,
    tableColumnFilters,
    setTableColumnFilters: setDetailReportTableColumnFilters,
    clearTableColumnFilters: clearDetailReportTableColumnFilters,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  const renderProgressBar = () => {
    return <ProgressBar mode="indeterminate" style={{ height: "6px" }} />;
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      {isLoading && renderProgressBar()}
      <ReservationsDetailReport {...ReservationsDetailReportProps} />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    initReservationsDetailReportScreen: () =>
      dispatch(initializeReservationsDetailReportScreen()),
    fetchReservationsDetailReport: (payload) =>
      dispatch(fetchReservationsDetailReport(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    fetchRateAdminNetworkDD: (payload) =>
      dispatch(fetchRateAdminNetworkDD(payload)),
    fetchLocationDD: (payload) => dispatch(fetchLocationDD(payload)),
    exportReservationsDetailReport: (payload) =>
      dispatch(exportReservationsDetailReport(payload)),
    setIsSearch: (payload) => dispatch(setIsSearch(payload)),
    setDetailReportFilters: (filters) =>
      dispatch(setDetailReportFilters(filters)),
    clearDetailReportFilters: () =>
      dispatch(clearDetailReportFilters()),
    setDetailReportTableColumnFilters: (filters) =>
      dispatch(setDetailReportTableColumnFilters(filters)),
    clearDetailReportTableColumnFilters: () =>
      dispatch(clearDetailReportTableColumnFilters()),
    saveDetailReportTableState: (payload) =>
      dispatch(saveDetailReportTableState(payload)),
  };
};

//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {
    isLoading: selectFromReservationsDetailReportReducer(state, "isLoading"),
    isSearch: selectFromReservationsDetailReportReducer(
      state,
      "isSearch"
    ),
    isReservationsDetailReportCreateSuccess:
      selectFromReservationsDetailReportReducer(
        state,
        "isReservationsDetailReportCreateSuccess"
      ),
    ReservationsDetailReportListview: selectFromReservationsDetailReportReducer(
      state,
      "ReservationsDetailReportListview"
    ),
    showPageLevelLoader: selectFromReservationsDetailReportReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromReservationsDetailReportReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromReservationsDetailReportReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromReservationsDetailReportReducer(
      state,
      "isFetchingGridData"
    ),
    RateNetworkDD: selectFromRateAdminRatesReducer(state, "RateNetworkDD"),
    locationDD: selectFromLocationReducer(state, "locationDD"),
    isReservationsDetailReportExportError:
      selectFromReservationsDetailReportReducer(
        state,
        "isReservationsDetailReportExportError"
      ),
    isReservationsDetailReportExportSuccess:
      selectFromReservationsDetailReportReducer(
        state,
        "isReservationsDetailReportExportSuccess"
      ),
    detailReportFilters: selectFromReservationsDetailReportReducer(
      state,
      "detailReportFilters"
    ),
    tableColumnFilters: selectFromReservationsDetailReportReducer(
      state,
      "tableColumnFilters"
    ),
    savedTableState: selectFromReservationsDetailReportReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromReservationsDetailReportReducer = (state, path) => {
  return selectReservationsDetailReportReducer(state)[path];
};

const selectReservationsDetailReportReducer = ({
  ReservationsDetailReportReducer,
}) => {
  return ReservationsDetailReportReducer;
};

// For Network
const selectFromRateAdminRatesReducer = (state, path) => {
  return selectRateAdminRatesReducer(state)[path];
};

const selectRateAdminRatesReducer = ({ rateadminRatesReducer }) => {
  return rateadminRatesReducer;
};
//Location
const selectFromLocationReducer = (state, path) => {
  return selectLocationReducer(state)[path];
};
const selectLocationReducer = ({ locationReducer }) => {
  return locationReducer;
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReservationsDetailReportScreen);
